import eventBus from "../services/event-bus";
import { removeClass } from "../utils/dom";
import elementExists from "../utils/element-exists";

// import { selectDoc, addClass , removeClass } from "../utils/utils";
let ProductForm = function ($product_or_id = false, $container = false) {
  let $this = {};
  $this.product_or_id = $product_or_id;
  if ($container) $this.container = $container;
  $this.productSelect = false;
  $this.productJson = false;
  $this.variantOptions = {};
  $this.optionsInitialized = false;

  $this.classes = {
    cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
    hidden: "d-none",
    visibilityHidden: "sr-only",
    inputError: "input--error",
    productOnSale: "price--on-sale",
    productUnitAvailable: "price--unit-available",
    productUnavailable: "price--unavailable",
    productSoldOut: "price--sold-out",
    cartImage: "cart-popup-item__image",
    productFormErrorMessageWrapperHidden:
      "product-form__error-message-wrapper--hidden",
    variantSoldOut: "product-form--variant-sold-out",
    addingToCart: "loading",
  };
  $this.selectors = {
    addToCart: "[sh-add-to-cart]",
    addToCartText: "[sh-add-to-cart-text]",
    loader: "[data-loader]",
    productForm: "[data-product-form]",
    priceContainer: "[data-price]",
    regularPrice: "[data-regular-price]",
    salePrice: "[data-sale-price]",
    unitPrice: "[data-unit-price]",
    unitPriceBaseUnit: "[data-unit-price-base-unit]",
    productPolicies: "[data-product-policies]",
    swatchOptions: "[data-swatch-option]",
    swatchValues: "[data-swatch-value]",
    optionSelect: "[sh-option-select]",
  };

  $this.init = function () {
    if ($this.product_or_id) {
      // if product init product
      let product = $this.validateProduct($this.product_or_id);

      if (product) {
        $this.initProduct(product, $this.product_or_id);
      }
    }
  };
  $this.validateProduct = function (product_or_id) {
    let product = false;
    if (typeof product_or_id == "object") {
      product = product_or_id;
    } else if (typeof product_or_id == "string") {
      try {
        product = JSON.parse(
          document.getElementById("ProductJson-" + product_or_id).innerHTML
        );
      } catch ($e) {
        product = false;
      }
    }
    return product;
  };
  /**
   * Accepts a product object or id
   * If a product object is passed, it expects the container and ProductSelect
   * to have the product ID specifically on their ids ProductXXX-product.id
   *
   */
  $this.initProduct = function (product, product_or_id) {
    $this.product = product;
    let select = $this.container.querySelector($this.selectors.optionSelect);
    if (elementExists(select)) {
      $this.productSelect = select.getAttribute("id");
    } else {
      $this.productSelect = false;
    }
    $this.createOptionMap();
    $this.addElements();
    // $this.QuantityComponent = new $theme.QuantityComponent( $this.container.find( '[sh-quantity-component]') )
    // // initialize product selector

    // // add to cart handler
    $this.form.addEventListener("submit", function ($e) {
      $e.preventDefault();
      $this.addToCart($e);
    });
    // return $this.product;
  };

  $this.addElements = function () {
    $this.form = $this.container.querySelector($this.selectors.productForm);
    $this.addToCartButton = $this.container.querySelector(
      $this.selectors.addToCartButton
    );
    $this.addToCartText = $this.container.querySelector(
      $this.selectors.addToCartText
    );
    $this.swatchOptions = $this.container.querySelectorAll(
      $this.selectors.swatchOptions
    );
    $this.swatchValues = $this.container.querySelectorAll(
      $this.selectors.swatchValues
    );
    $this.priceContainer = $this.container.querySelector(
      $this.selectors.priceContainer
    );
    $this.regularPrice = $this.priceContainer.querySelectorAll(
      $this.selectors.regularPrice
    );
    $this.salePrice = $this.priceContainer.querySelector(
      $this.selectors.salePrice
    );
    // $this.unitPrice = $this.priceContainer.querySelector($this.selectors.unitPrice);
    // $this.unitPriceBaseUnit = $this.priceContainer.querySelector($this.selectors.unitPriceBaseUnit);

    if ($this.product.variants.length > 1 && $this.productSelect) {
      if ($this.swatchOptions.length > 0) {
        $this.initSwatchOptions();
      }
      $this.addSelectCallBack();
    }
  };

  $this.addSelectCallBack = function () {
    let selector = new Shopify.OptionSelectors($this.productSelect, {
      product: $this.product,
      onVariantSelected: $this.selectCallback,
    });
  };

  $this.selectCallback = function (variant, selector) {
    if ($this.optionsInitialized == false) {
      $this.initOptionSelectors();
    }

    $this.variant = variant;
    $this.resetState();
    $this.updatePrice();
    eventBus.dispatch(eventBus.types.OptionsSelected, variant);
  };

  $this.resetState = function () {
    removeClass($this.priceContainer, $this.classes.productUnavailable);
    removeClass($this.priceContainer, $this.classes.productOnSale);
    removeClass($this.priceContainer, $this.classes.productSoldOut);
    $this.priceContainer.removeAttribute("aria-hidden");

    removeClass($this.container, $this.classes.productUnavailable);
    removeClass($this.container, $this.classes.productOnSale);
    removeClass($this.container, $this.classes.productUnitAvailable);
    removeClass($this.container, $this.classes.productSoldOut);
    $this.container.removeAttribute("aria-hidden");
  };

  $this.updatePrice = function () {
    // this.$productPolicies.removeClass(this.classes.visibilityHidden);
    // Unavailable
    if (!$this.variant) {
      $this.update_variant_unavailable();
      return;
    }
    // Sold out
    if (!$this.variant.available) {
      $this.update_variant_unavailable();
    }
    // On sale
    if ($this.variant.compare_at_price > $this.variant.price) {
      $this.update_variant_on_sale();
    } else {
      $this.update_variant_regular();
    }
    // Unit price
    // if ($this.variant.unit_price) {
    //   $this.update_variant_unit()
    // }
  };

  $this.createOptionMap = function () {
    $this.optionsMap = [];

    for (let i = 0; i < $this.product.variants.length; i++) {
      let variant = $this.product.variants[i];

      if (variant.available) {
        // Gathering values for the 1st drop-down.
        $this.optionsMap["root"] = $this.optionsMap["root"] || [];
        $this.optionsMap["root"].push(variant.option1);
        $this.optionsMap["root"] = Shopify.uniq($this.optionsMap["root"]);

        // Gathering values for the 2nd drop-down.
        if ($this.product.options.length > 1) {
          var key = variant.option1;
          $this.optionsMap[key] = $this.optionsMap[key] || [];
          $this.optionsMap[key].push(variant.option2);
          $this.optionsMap[key] = Shopify.uniq($this.optionsMap[key]);
        }

        // Gathering values for the 3rd drop-down.
        if ($this.product.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          $this.optionsMap[key] = $this.optionsMap[key] || [];
          $this.optionsMap[key].push(variant.option3);
          $this.optionsMap[key] = Shopify.uniq($this.optionsMap[key]);
        }
      }
    }
  };

  $this.initOptionSelectors = () => {
    let optionInputs = $this.container.querySelectorAll(
      ".single-option-selector"
    );

    $this.optionsInitialized = true;

    // Update options right away.
    $this.updateOptionsInSelector(0);
    if ($this.product.options.length > 1) $this.updateOptionsInSelector(1);
    if ($this.product.options.length === 3) $this.updateOptionsInSelector(2);

    // When there is an update in the first dropdown.
    optionInputs[0].addEventListener("change", () => {
      $this.updateOptionsInSelector(1);
      if ($this.product.options.length === 3) $this.updateOptionsInSelector(2);
      return true;
    });

    // When there is an update in the second dropdown.
    if (optionInputs[1]) {
      optionInputs[1].addEventListener("change", () => {
        if ($this.product.options.length === 3)
          $this.updateOptionsInSelector(2);
        return true;
      });
    }

    if ($this.product.options.length > 0) {
      if (optionInputs[0].querySelector("option").length === 1) {
        optionInputs[0].querySelector("option").classList.add("single-option");
      }
    }

    if ($this.product.options.length > 1) {
      if (optionInputs[1].querySelector("option").length == 1) {
        optionInputs[1].classList.add("single-option");
      }
    }
    if ($this.product.options.length > 2) {
      if (optionInputs[2].querySelector("option").length == 1) {
        optionInputs[2].classList.add("single-option");
      }
    }
  };

  $this.updateOptionsInSelector = (selectorIndex) => {
    let key = "";
    let selector = "";
    const optionInputs = $this.container.querySelectorAll(
      ".single-option-selector"
    );

    switch (selectorIndex) {
      case 0:
        key = "root";
        selector = optionInputs[0];
        break;
      case 1:
        key = optionInputs[0].value;
        selector = optionInputs[1];
        break;
      case 2:
        key = optionInputs[0].value;
        key += " / " + optionInputs[1].value;
        selector = optionInputs[2];
        break;
      default:
        break;
    }
    if (typeof selector == "undefined") return;
    let initialValue = selector.value;
    selector.value = "";

    let availableOptions = $this.optionsMap[key];

    if (typeof availableOptions == "undefined") return;
    selector.innerHTML = null;
    for (let i = 0; i < availableOptions.length; i++) {
      let option = availableOptions[i];

      let newOption = document.createElement("option");
      newOption.value = option;
      newOption.innerHTML = option;

      selector.add(newOption);
    }

    if (availableOptions.indexOf(initialValue) !== -1) {
      selector.value = initialValue;
    }

    if ($this.swatchOptions.length > 0) {
      let swatchOptions = $this.container.querySelectorAll(
        '.swatch[data-option-index="' + selectorIndex + '"] .swatch-element'
      );

      swatchOptions.forEach((elm) => {
        let value = elm.dataset.value;
        let option = elm;

        if (availableOptions.indexOf(value) !== -1) {
          // BEGIN --------
          const singleOptions = $this.form.querySelectorAll(
            ".single-option-selector"
          );
          const radioOptions = $this.form.querySelectorAll(
            "[data-swatch-option]"
          );

          radioOptions.forEach((options, i) => {
            let radioElmsHolders = options.querySelectorAll(".swatch-element");
            if (i !== 0) {
              radioElmsHolders.forEach((radioElmsHolder) => {
                let radioElm = radioElmsHolder.querySelector(
                  'input[type="radio"]'
                );
                radioElmsHolder.style.opacity = 0.4;
                radioElmsHolder.classList.remove("active");
                radioElmsHolder.classList.add("inactive");
                radioElm.disabled = true;
                radioElm.checked = false;
              });
            }
          });

          // populate the next level of selection
          // first section will always be availible
          // example, if user has selected a color, update the sizes to show/hide the options
          singleOptions.forEach((selectElm) => {
            let selectOptions = selectElm.querySelectorAll("option");
            let selectedValue = selectElm.value;

            selectOptions.forEach((option) => {
              let optionValue = option.value;

              radioOptions.forEach((options, i) => {
                let radioElmsHolders =
                  options.querySelectorAll(".swatch-element");
                if (i !== 0) {
                  radioElmsHolders.forEach((radioElmsHolder) => {
                    let radioElm = radioElmsHolder.querySelector(
                      'input[type="radio"]'
                    );
                    if (radioElm.value === optionValue) {
                      if (selectedValue === "") {
                        // select has no value, could be sold out
                      } else {
                        radioElmsHolder.style.opacity = 1;
                        radioElm.disabled = false;
                        radioElmsHolder.classList.remove("inactive");
                        if (selectedValue === optionValue) {
                          radioElmsHolder.classList.add("active");
                          radioElm.checked = true;
                        }
                      }
                    }
                  });
                }
              });
            });
          });
          // END ----------
        }
      });

      if ($this.variant == null) {
        const selectElem = "option=" + selectorIndex;
        const first = $this.container.querySelectorAll(
          '[name="' + selectElem + '"]'
        );
        if (first.length > 0) {
          first[0].dispatchEvent(new Event("click"));
        }
      }
    }

    selector.dispatchEvent(new Event("change"));
  };

  // update the add to cart button on variant change
  $this.updateAddToCart = function () {
    if ($this.variant) {
      if ($this.variant.available) {
        $this.addToCartButton.removeAttribute("aria-disabled");
        $this.addToCartButton.setAttribute(
          "aria-label",
          theme.strings.addToCart
        );
        $this.addToCartText.innerText = theme.strings.addToCart;
        $this.form.classList.remove($this.classes.variantSoldOut);
      } else {
        // Variant is sold out, disable submit button and change the text.
        $this.addToCartButton.setAttribute("aria-disabled", true);
        $this.addToCartButton.setAttribute("aria-label", theme.strings.soldOut);
        $this.addToCartText.innerText = theme.strings.soldOut;
        $this.form.classList.add($this.classes.variantSoldOut);
      }
    } else {
      // The variant doesn't exist, disable submit button and change the text.
      $this.addToCartButton.setAttribute("aria-disabled", true);
      $this.addToCartButton.setAttribute(
        "aria-label",
        theme.strings.unavailable
      );
      $this.addToCartText.innerText = theme.strings.unavailable;
      $this.form.classList.add($this.classes.variantSoldOut);
    }
  };

  $this.update_variant_unavailable = function () {
    $this.container.classList.add($this.classes.productUnavailable);
    $this.container.classList.add($this.classes.productUnavailable);
    $this.priceContainer.classList
      .add($this.classes.productUnavailable)
      // .attr("aria-hidden", true);
    // this.$productPolicies.addClass(this.classes.visibilityHidden);
  };

  $this.update_variant_regular = function () {
    $this.regularPrice.forEach((el) => {
      el.innerText = Shopify.formatMoney($this.variant.price);
    });
  };

  $this.update_variant_on_sale = function () {
    $this.regularPrice.forEach((el) => {
      el.innerText = Shopify.formatMoney($this.variant.compare_at_price);
    });
    $this.salePrice.innerText = Shopify.formatMoney($this.variant.price);
    $this.priceContainer.classList.add($this.classes.productOnSale);
  };

  $this.update_variant_unit = function () {
    $this.unitPrice.innerText = $theme.Currency.formatMoney(
      $this.variant.unit_price,
      $theme.moneyFormat
    );
    $this.unitPriceBaseUnit.innerText = $this._getBaseUnit($this.variant);
    $this.$this.priceContainer.add($this.classes.productUnitAvailable);
  };

  /**
   * Add the item to the cart
   * @param {*} $data
   */
  $this.addToCart = function ($data) {
    const formData = new FormData($this.form);

    let formDataObject = Object.assign(
      ...Array.from(formData.entries(), ([x, y]) => ({ [x]: y }))
    );
    
    eventBus.dispatch(eventBus.types.AddingToCart, $this.product);

    let data = {
      items: $this.addCartItems(formDataObject),
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => {
        response.json().then((json) => {
          if (json.items) {
            const variant = json.items[0];
            eventBus.dispatch(eventBus.types.AddedToCart, {
              variant: variant,
              success: true,
            });
          } else {
            eventBus.dispatch(eventBus.types.AddedToCart, {
              variant: null,
              success: false,
            });
            // let errorElm = $data.target.querySelector('.error-message');
            // errorElm.innerHTML = json.description;
            alert(json.description);
          }
        });
      })
      .catch((error) => {
        alert("There was an error adding your item to the cart");
      });
  };
  /**
   * Look at the form and create the cart items array
   * @param {*} formDataObject
   * @returns []
   */
  $this.addCartItems = function (formDataObject) {
    let items = [];
    let groups = [];
    // console.log(formDataObject);
    if (formDataObject.id && formDataObject.quantity) {
      let item = {
        id: formDataObject.id,
        quantity: formDataObject.quantity,
        properties: { },
      };
      item.properties._uid =$this.itemUID(item);
      for (let key in formDataObject) {
        let regex = /^properties\[\w+\]/gm;
        if (key.search(regex) > -1) {
          let property = key.replace("properties[", "").replace("]", "");
          item.properties[property] = formDataObject[key];
        }
      }
      items.push(item);
    }
    for (let key in formDataObject) {
      const regex = /items\[(\d)]/gm;
      if (key.search(regex) > -1) {
        let group_name = key.replace("items[", "").replace("]", "");
        let property_name = key.replace(regex, "");
        group_name = group_name.replace(property_name, "");
        groups.push(group_name);
      }
    }

    if (groups.length > 0) {
      let groupItems = {};
      groups.forEach((group) => {
        for (let key in formDataObject) {
          if (key.indexOf(`items[${group}]`) > -1) {
            let property_name = key.replace(`items[${group}]`, "");
            if (!groupItems.hasOwnProperty(group)) {
              groupItems[group] = {
                properties: {},
              };
            }
            if (property_name !== "quantity" && property_name !== "id") {
              let regex = /^properties\[\w+\]/gm;
              if (property_name.search(regex) > -1) {
                let property = property_name
                  .replace("properties[", "")
                  .replace("]", "");
                groupItems[group].properties[property] = formDataObject[key];
              }
            } else {
              groupItems[group][property_name] = formDataObject[key];
            }
          }
        }
      });
      
      if (groupItems != {}) {
        for (let key in groupItems) {
          let item = groupItems[key];
          item.properties._uid =$this.itemUID(item);
          items.push(item);
        }
      }
    }
    
    return items;
  };

  $this.itemUID = function ( item ) {
    const uid = btoa( item.id + JSON.stringify(item.properties) );
    return uid;
  }

  // we are using swatches
  // look for the swatch option radios
  // add event listeners for change
  // update the single option selectors added by shopify
  $this.initSwatchOptions = function () {
    // $this.updatedOption();

    $this.swatchOptions.forEach(function (option) {
      let radios = option.querySelectorAll('input[type="radio"]');

      radios.forEach(function (radio) {
        radio.addEventListener("change", function (evt) {
          let optionIndex = evt.target
            .closest($this.selectors.swatchOptions)
            .getAttribute("data-option-index");
          let optionValue = evt.target.value;

          const optionSelector = $this.form.querySelectorAll(
            ".single-option-selector"
          )[optionIndex];
          optionSelector.value = optionValue;

          // $this.updatedOption();

          optionSelector.dispatchEvent(new Event("change"));
        });
      });
    });
  };

  return $this;
};

export default ProductForm;